import { makeStyles } from '@material-ui/core/styles'
import { ALIGN } from '@v4/constants/quiz'
import { getFontScale } from './AnswerTypes.utils'

const useStyles = makeStyles(
	theme => {
		const textBreakpoint = theme.breakpoints.up('sm')

		return {
			title: {
				fontSize: ({ textSize, withOldTextSize }) =>
					`calc(${theme.typography.h3.fontSize} * ${getFontScale(textSize, withOldTextSize)})`,
				transition: theme.transitions.create(['font-size']),
				[textBreakpoint]: {
					fontSize: ({ textSize, withOldTextSize }) =>
						`calc(${theme.typography.h3[textBreakpoint].fontSize} * ${getFontScale(
							textSize,
							withOldTextSize,
						)})`,
				},
				textAlign: ({ align }) => (theme.direction === 'rtl' && align !== ALIGN.CENTER ? 'right' : null),
			},
			instruction: {
				marginTop: theme.spacing(2),

				'& > div': {
					marginTop: theme.spacing(2),
				},
			},
			media: {
				marginTop: theme.spacing(2),
			},
			errorWrap: {
				width: '100%',
				position: 'relative',
			},
			error: {
				position: 'absolute',
				bottom: theme.spacing(-8),
				overflow: 'hidden',
				'&$anchorOriginBottomLeft': {
					left: 0,
				},
			},
			anchorOriginBottomLeft: {},
		}
	},
	{ name: 'Questions-AnswerTypes' },
)

export default useStyles
